export enum PaymentType {
  'BTC' = 'BTC',
  'PayPal' = 'PayPal',
  'Wire Transfer' = 'Wire Transfer',
  'TRC20' = 'TRC20',
  'ERC20' = 'ERC20',
  'Neteller' = 'Neteller',
  'Skrill' = 'Skrill',
  'Pix' = 'Pix',
}

export const LABEL_BY_PAYMENT_TYPE = {
  [PaymentType['Wire Transfer']]: $localize`:@@payment.account:Payment Account`,
  [PaymentType.BTC]: 'BTC Wallet',
  [PaymentType.TRC20]: 'TRC20 Wallet',
  [PaymentType.ERC20]: 'ERC20 Wallet',
  [PaymentType.Neteller]: 'EMAIL/Account Neteller',
  [PaymentType.Skrill]: 'EMAIL/Account Skrill',
  [PaymentType.Pix]: 'Chave Pix',
};
